var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949","active-value":"1","size":"small","inactive-value":"0","disabled":_vm.disabled},on:{"change":_vm.change},model:{value:(_vm.option),callback:function ($$v) {_vm.option=$$v},expression:"option"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-633cabd8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SwitchTabs.vue
// module id = null
// module chunks = 